import {
    useMemo,
} from 'react'
import StatusHandler from 'app/shared-components/StatusHandler'
import useGetContact from '../hooks/useGetContact'
import ContactSAPContactForm from './ContactSAPContactForm'
import {
    SAPContactSyncForm,
} from './ContactSAPContact.types'

export default function ContactSAPContact({
    id,
}: Readonly<{
    id: number
}>) {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetContact(id)

    const formData = useMemo((): SAPContactSyncForm => {
        return {
            sapEmployeeId: data?.sapEmployeeId,
            sapEmployeeIdentificationNumber: data?.sapEmployeeIdentificationNumber,
        }
    }, [data])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <ContactSAPContactForm
                data={formData}
                contactId={id}
                refetch={invalidate}
            />
        </StatusHandler>
    )
}
